import Head from "next/head";
const Meta = ({
  title = "AmateurMoto.com | Your Amateur Motocross Headquarters",
  keyword = "motocross 250 450 65 85 50 cc dirtbike racing results loretta lynns national championship regional area qualifer",
  desc = "Your one stop shop for everything amateur motocross related."
}) => {
  return <div data-sentry-component="Meta" data-sentry-source-file="Meta.jsx">
      <Head data-sentry-element="Head" data-sentry-source-file="Meta.jsx">
        <title>{title}</title>
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        {/* <link rel="manifest" href="/site.webmanifest" /> */}
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
        <meta name="msapplication-TileColor" content="#da532c" data-sentry-element="meta" data-sentry-source-file="Meta.jsx" />
        <meta name="theme-color" content="#ffffff" data-sentry-element="meta" data-sentry-source-file="Meta.jsx" />
        <meta name="description" content={desc} data-sentry-element="meta" data-sentry-source-file="Meta.jsx" />
        <meta name="keyword" content={keyword} data-sentry-element="meta" data-sentry-source-file="Meta.jsx" />
        <meta property="og:title" content={title} data-sentry-element="meta" data-sentry-source-file="Meta.jsx" />
        <meta property="og:image" content="https://amateurmoto.com/images/site-preview.jpg" data-sentry-element="meta" data-sentry-source-file="Meta.jsx" />
      </Head>
    </div>;
};
export default Meta;